import { unifiedDataStore } from "../services/UnifiedDataStore";
import { gameActionsService } from "./services/GameActionsService";
import { useGameplayStore } from "./stores/useGameplayStore";

export type TutorialSkipOutcome = "discarded" | "gave_up" | "none";

/**
 * End the tutorial game when the player skips the walkthrough.
 *
 * - Before the first move nothing has been played, so the game is abandoned
 *   like any abandoned game: no report, history or telemetry; the saved slot
 *   is cleared and the board reset (so the next New Game is the session's
 *   first, i.e. today's daily when available).
 * - After a move it is a normal give-up, recorded like any other game.
 * - If the game is not in play (already won, loading) nothing changes.
 */
export async function skipTutorialGame(): Promise<TutorialSkipOutcome> {
  const { gameStatus, playerPath } = useGameplayStore.getState();
  if (gameStatus !== "playing") return "none";
  if (playerPath.length <= 1) {
    await unifiedDataStore.clearCurrentGame("regular");
    useGameplayStore.getState().resetGameState();
    return "discarded";
  }
  await gameActionsService.giveUp();
  return "gave_up";
}
